import { Component, Inject, Input} from 'ng-metadata/core';

import {QuickLink} from "../quickLink.service";
import {beacon, PrimolyticsService} from "../../../analytics/primolytics.service";
import {StringUtils} from "../../../nddUtils/stringUtils.service";
import {PrimoResponse} from "../../../infra/dataStructures/PrimoResponses/doc.interfcae";
import {PnxUtil} from "../../../nddUtils/pnxUtil.service";

@Component({
    selector: 'prm-ai-insights-link',
    templateUrl: 'components/search/quickLink/aiInsights/ai-insights-link.html'
})

export class PrmAiInsightsLink {
    private _link: any;
    @Input() public item: PrimoResponse.IDoc;
    @Input() isFullDisplay: boolean;//true in full display and false in brief result page


    constructor(@Inject('availabilityLineIcons') private availabilityLineIcons: Object[],
                private linksService: QuickLink,
                private primolyticsService: PrimolyticsService,
                private stringUtils: StringUtils,
                private pnxUtil : PnxUtil,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$translate') private $translate: ng.translate.ITranslateService) { }

    ngOnInit() {
        this.updateAiInsightsLink();
    }

    get link() {
        return this._link;
    }

    set link(link) {
        this._link = link;
    }

    getTitle() {
        return this.pnxUtil.getValue(this.item, 'display', 'title');
    }

    updateAiInsightsLink() {
        this.linksService.calculateAiInsightsLink(this.item).then((linkToReturn: any) => {
            this._link = linkToReturn[0];
        });
    }

    public runAiInsightLinkAnalytics(link) {
        this.reportAiInsightsLink(link);
    }

    @beacon({ 'p': 'linksService', 'op': 'AI_Insights' })
    public reportAiInsightsLink(item) {
    }

    private getAiLinkAriaLabel(link) {
        if(!this.$translate.isReady()) {
            return undefined;
        }
        return this.stringUtils.decode(
            this.$translate.instant(link.ariaLabel, {title: this.item.pnx.display['title'][0]})
        )
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/quickLink/aiInsights/aiInsightsLink.directive.ts